import styled from 'styled-components';

import { LinkButton } from 'components/ui/Button';
import { ButtonContent } from 'components/ui/Button/Button.styles';

import { colours } from 'themes/default';

export const StyledLinkButton = styled(LinkButton)`
  padding: 0;
  width: 200px;

  ${ButtonContent} {
    justify-content: flex-start;
    font-size: 14px;
    font-weight: 500;

    > :first-child {
      margin-right: 10px;
    }
  }
`;

export const StyledForm = styled.form`
  padding: 16px;
  background-color: white;
  width: inherit;
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
`;

export const StyledTextArea = styled.textarea`
  display: block;
  box-sizing: border-box;
  border-color: ${colours.Greyscale.SilverGrey};
  border-radius: 5px;
  width: 100%;
  height: 200px;
  resize: none;
`;

export const TextAreaContainer = styled.div`
  padding: 16px;
  background-color: ${colours.Shades.BlueShade20};
  width: inherit;
`;

export const ErrorMessage = styled.span`
  font-size: 14px;
  color: red;
  display: block;
`;

export const StyledButtonWrapper = styled.div`
  display: inline-block;
  margin-right: 20px;
`;
